<template><div><h1 id="korrespondenztyp" tabindex="-1"><a class="header-anchor" href="#korrespondenztyp"><span>Korrespondenztyp</span></a></h1>
<p>Korrespondenztyp — Definiert Korrespondenztypen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Korrespondenztypen steuern das Verhalten des Systems im Hintergrund. In der aktuellen Version wird durch den Korrespondenztyp lediglich das Outputformat bestimmt. Für die Zukunft sind weitere Steuerungsmöglichkeiten denkbar, abhängig von den Bedürfnissen. Diese Tabelle wird durch ARENAE unterhalten und kann nicht geändert werden.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Korrespondenztypen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Typ</dt>
<dd>Korrespondenztyp.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Korrespondenztyps.</dd>
<dt>Outputtyp</dt>
<dd>Hier wird der Outputtyp definiert. Folgende Möglichkeiten stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Document Output</td>
<td>Korrespondenz wird über Document Output erstellt.</td>
</tr>
<tr>
<td>Exportdatei</td>
<td>Die Daten für die Korrespondenz wird in eine Exportdatei ausgegeben.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Exportformat</dt>
<dd>Exportformat für die Ausgabe der Daten in eine Exportdatei.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>Drucken...</dt>
<dd>Druckt die Korrespondenztypen aus.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/korrespondenz.html">Korrspondenz</RouteLink></p>
</div></template>


